import { Button } from "@mui/material";
import { ChatMessageWithParts } from "src/views/assistant/types";
import { useChatContext } from "../context/ChatContext";
import { useUpdateChatRanking } from "src/views/assistant/AssistantServices";

type SelectResponseButtonProps = {
  chatMessage: ChatMessageWithParts;
  dialogue: ChatMessageWithParts[];
  setAsPreferredMessage: (id: string) => void;
};

const SelectResponseButton = ({
  chatMessage,
  dialogue,
  setAsPreferredMessage,
}: SelectResponseButtonProps) => {
  const { dialogueId } = useChatContext();

  const { mutate: updateChatRanking }: any = useUpdateChatRanking();

  const handleClick = () => {
    if (!chatMessage.parent_id || !chatMessage.id) return;

    const siblings = dialogue.filter(
      (msg) => msg.parent_id === chatMessage.parent_id,
    );

    const rankingUpdate = siblings.map((msg) => ({
      message_id: msg.id,
      ranking: msg.id === chatMessage.id ? 1 : 0,
    }));

    updateChatRanking({
      dialogue_id: dialogueId,
      context_dialogue: dialogue,
      ranking_update: rankingUpdate,
    });

    setAsPreferredMessage(chatMessage.id);
  };

  return (
    <Button
      color="primary"
      variant="contained"
      size="small"
      disableElevation
      onClick={handleClick}
      data-attr="assistant:btn:prefer-this-response"
    >
      I prefer this
    </Button>
  );
};

export default SelectResponseButton;
